import React, { useEffect, useState, useCallback } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import "../../../css/App.css";
import "../../../css/color.css";
import _ from "lodash";
//import SearchIcon from "@mui/icons-material/Search";
//import { IconButton } from "@mui/material";
import {DISPLAY_PAGE_SIZE} from "../../../constants/constants"
import TokenService from "../../../service/TokenService";
import ExportToExcelCustomButton from "../../../components/ExportToExcelButtonCustom";
import ExportToPDFCustomButton from "../../../components/ExportPDFfromTable.js";
import ListDynamicTable from "../../../CustomComponant/ListDynamicTable";
import dayjs from "dayjs";
import { REPORT_TYPE } from "../../../constants/constants.js";
import CircularProgress from "@mui/material/CircularProgress";
import apiClient from "../../../BaseUrl/apiClient.js"
import SearchTextField from "../../../CustomComponant/SearchTextField.js";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton } from "@mui/material";
//import SearchTextField from "../../../CustomComponant/SearchTextField";
function PoReport({ consignee, reporttype, reportsubtype,heading }) {
  const [reportData, setReportData] = useState([]);
  const [reportAllData, setReportAllData] = useState([]);
  const [srcinddata, setSrcinddata] = useState("");

  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1); // set the current page
  const pageSize = DISPLAY_PAGE_SIZE;
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const [pgHeader, setpgHeader] = useState("");

 // const [pageLoader, setPageLoader] = useState(true);

  const today = dayjs().startOf("day");

  const [columns, setColumns] = useState([""]);
  const [columnNames, setColumnNames] = useState([""]);

  // Debounced search function
  const fetchData = useCallback(
    _.debounce(async (searchTerm) => {
      let apiEndPoint = "";
      try {
       // setPageLoader(true);
        if (reporttype === REPORT_TYPE.PO_NOT_GENERATED) {
          //setColumns(["totaldata","ConsigneeCode","indentnumber","indreceiptdate", "daydiff","itemname",]);
          // setColumnNames(["Total Rows","Consignee","Indent Number","Indent Date", "Pending Days from Indent","Item Name",]);
          setColumns([
            //"ConsigneeCode",
            "Shop",
            "indentnumber",
            "itemname",
            "indreceiptdate",
            "daydiff",
            "urgency",
            
          ]);
          setColumnNames([
           // "Consignee Code",
            "Consignee Name",
            "Indent Number",
            "Item Name",
            "Indent Date",
            "Pending Days from Indent",
            "Urgency",
          ]);

          apiEndPoint = "/getAllIndentList";
        } else if (reporttype === REPORT_TYPE.ITEM_NOT_RECEIVED) {
          setColumns([
            //"POConsignee",
            "Shop",
            "IndentNumber",
            "ponumber",
            "poitemname",
            "podate",
            
//"party_contact",
            "daydiff",
            "DPdate",
            "dpdaydiff",
            "party_name",
           
          ]); // keys from your data objects
          setColumnNames([
            //"Consignee Code",
            "Consignee Name",
            "Indent Number",
            "PO Number",
            "Item Name",
            "PO Date",
            
//"Party Contact",
            "Days Pending from PO",
            "DP Date",
          "Remaining Days for DP",
            "Supplier",
           
          ]);
          apiEndPoint = "/getitemNotReceivedList";
        } else if (reporttype === REPORT_TYPE.SUITABILITY_PENDING) {
          setColumns([
           // "consignee",
            "Shop",
            "ponumber",
            "poitemname",
            // "podate",
            "getpassnumber",
            "itemReceivedDate",
            "daydiff",
            // "DPdate",
            "pushdate",
            "pushdiff",
            
          ]); // keys from your data objects
          setColumnNames([
           // "Consignee Code",
            "Consignee Name",
            "PO Number",
            "Item Name",
            // "PO Date",
            "Gate Pass/Memo Number",
            "Item Receiving Date ",
            "Pending Days from Receiving",
            // "DP Date",
            "Suitability Push Date",
            "Pending Days from Push Date",
            
          ]);
          apiEndPoint = "/getsuitabilitypendingList";
        } else if (reporttype === REPORT_TYPE.BILL_RECEIVED_PENDING) {
          setColumns([
            //"consignee",
            "Shop",
            "poNumber",
            "POItemName",
            // "PODate",
            
            //"DPDate",
            "SuitabilityDate",
            "daydiff",
            
          ]); // keys from your data objects
          setColumnNames([
            //"Consignee Code",
            "Consignee Name",
            "PO Number",
            "Item Name",
            // "PO Date",
            
            //"DP Date",
            "Suitability Date",
            "Pending Days from Item Suitability",
          ]);
          apiEndPoint = "/getbillpendingList";
        } else if (reporttype === REPORT_TYPE.BILL_PASSING_PENDING) {
          setColumns([
            //"consignee",
            "Shop",
            "ponumber",
            "POItemName",
            "billnumber",
            "billdate",
            "billreceiptdate",
            "nodaldate",
            "daydiff",
          ]); // keys from your data objects
          setColumnNames([
            //"Consignee Code",
            "Consignee Name",
            "PO Number",
            "Item Name",
            "Bill Number",
            "Bill Date",
            "Bill Receiving Date",
            "Bill Push to COS/G",
            "Pending Days ",
          ]);
          apiEndPoint = "/pendingatCOSG";
        } else if (reporttype === REPORT_TYPE.CRN_PENDING) {
          setColumns([
            //"consignee",
            "Shop",
            "ponumber",
            "POItemName",
            "billnumber",
            "billdate",
            "billpassingdate",
            "daydiff",
          ]); // keys from your data objects
          setColumnNames([
            //"Consignee Code",
            "Consignee Name",
            "PO Number",
            "Item Name",
            "Bill Number",
            "Bill Date",
            "Bill Passing Date",
            "Pending Days from Bill Passing",
          ]);
          apiEndPoint = "/pendingforaccount";
        } else if (reporttype === REPORT_TYPE.PAYMENT_PENDING) {
          setColumns([
            //"consignee",
            "Shop",
            "ponumber",
            "POItemName",
            "billnumber",
            "billdate",
            "crndate",
            "billsenttoaccountdate",
            "daydiff",
          ]); // keys from your data objects
          setColumnNames([
            //"Consignee Code",
            "Consignee Name",
            "PO Number",
            "Item Name",
           "Bill Number",
            "Bill Date",
            "CRN Date",
            "Hardcopy Sent to Account Date",
            "Pending Days from From CRN",
          ]);
          apiEndPoint = "/paymentpending";
        } else if (reporttype === REPORT_TYPE.PAID) {
          //			co6number	co6date	co7number	co7date	paymentdate	daydiff
          setColumns([
           // "consignee",
            "Shop",
            "ponumber",
          
            "PODate",
            "DPDate",
            "dpextension",
            "POQty",
            "POValue",

            "party_name",
            "POItemName",
            "billnumber",
            "billdate",
            "co6number",
            "co6date",
            "co7number",
            "co7date",
            "paymentdate",
          ]); // keys from your data objects
          setColumnNames([
           // "Consignee Code",
            "Consignee Name",
            "PO Number",
            "PO Date",
            "DP Date",
            "DP Extensions",
            "PO Qty",
            "PO Value",
          
            "Supplier",
            "Item Name",
            "Bill Number",
            "Bill Date",
            "CO6 Number",
            "CO6 Date",
            "CO7 Number",
            "CO7 Date",
            "Payment Date",
          ]);
          apiEndPoint = "/paymentpaid";
        }
        //uname	FullName	emailid	mobilenumber	role	consignee
        else if (reporttype === REPORT_TYPE.USER_LIST) {
          //			co6number	co6date	co7number	co7date	paymentdate	daydiff
          setColumns([
            "uname",
            "FullName",
            "emailid",
            "mobilenumber",
            "role",
            //"ConsigneeCode",
            "Shop",
            "LoginDetails",
          ]); // keys from your data objects
          setColumnNames([
            "User Name",
            "User Full Name",
            "E-Mail ID",
            "Mobile Number",
            "User Type",
            //"Consignee Code",
            "Consignee Name",
            "Last Login Details",
          ]);
          apiEndPoint = "/userList";
        } else {
          //   console.error("Unsupported report type:", reporttype);
          // Optionally, set default columns or take other action here
        }
        const allDataResponse = await apiClient.post(`${apiEndPoint}`, {
          uname: uname,
          limit: "0", // No limit
          offset: "0", // No offset
          srcinddata:searchTerm, // No search term for fetching all data
        });

        const allData = allDataResponse.data;
        // console.log(allData.length);
        const filteredData = allData.filter((subreport) => {
          // report type Indent List which PO Not Found
          if (reporttype === REPORT_TYPE.PO_NOT_GENERATED) {
            let dayDiffThreshold = 0;
            if (reportsubtype === 1) {
              dayDiffThreshold = 30;
            } else if (reportsubtype === 2) {
              dayDiffThreshold = 60;
            } else if (reportsubtype === 3) {
              dayDiffThreshold = 90;
            }

            // Apply filtering based on consignee and daydiff
            if (consignee === "Select All") {
              setpgHeader("All Indent List which PO Not Found");
              return subreport.daydiff >= dayDiffThreshold;
            } else {
              setpgHeader(
                `Indent List which PO Not Found for ${consignee}`
              );
              return (
                subreport.daydiff >= dayDiffThreshold &&
                subreport.ConsigneeCode === `${consignee}`
              );
            }
          } else if (reporttype === REPORT_TYPE.ITEM_NOT_RECEIVED) {
            
            if (consignee === "Select All") {
              if (reportsubtype === 1) {
                return dayjs(subreport.DPdate).isBefore(today);
              }
              if (reportsubtype === 2) {
                return (
                  dayjs(subreport.DPdate).isAfter(today) ||
                  dayjs(subreport.DPdate).isSame(today)
                );
              }
              if (reportsubtype === 3) {
                return (
                  dayjs(subreport.DPdate).isBetween(today, dayjs().add(1, 'week'), null, '[)')
                );
              }

              
            } else {
              if (reportsubtype === "All Data") {
                return subreport.POConsignee === `${consignee}`;
              }
              

                if (reportsubtype === 1 )
                  {
                    return (
                      dayjs(subreport.DPdate).isBefore(today) &&
                      subreport.POConsignee === `${consignee}`
                    );
                  }
                  if (reportsubtype === 2) {
                    return (
                      (dayjs(subreport.DPdate).isAfter(today) ||
                      dayjs(subreport.DPdate).isSame(today))
                      &&
                      subreport.POConsignee === `${consignee}`
                    );
                  }
                  if (reportsubtype === 3) {
                    return (
                      dayjs(subreport.DPdate).isBetween(today, dayjs().add(1, 'week'), null, '[)')
                    &&
                      subreport.POConsignee === `${consignee}`
                    );
                  }

            }
          } else if (reporttype === REPORT_TYPE.SUITABILITY_PENDING) {
            let dayDiffThreshold = 0;
            if (reportsubtype === 1) {
              dayDiffThreshold = 7;
            } else if (reportsubtype === 2) {
              dayDiffThreshold = 15;
            } else if (reportsubtype === 3) {
              dayDiffThreshold = 30;
            }

            // Apply filtering based on consignee and daydiff
            if (consignee === "Select All") {
              setpgHeader("All Suitability List");
              return subreport.daydiff >= dayDiffThreshold;
            } else {
              setpgHeader(`Suitability List for ${consignee}`);
              return (
                subreport.daydiff >= dayDiffThreshold &&
                subreport.consignee === `${consignee}`
              );
            }
          } else if (reporttype === REPORT_TYPE.BILL_RECEIVED_PENDING) {
            let dayDiffThreshold = 0;
            if (reportsubtype === 1) {
              dayDiffThreshold = 7;
            }

            // Apply filtering based on consignee and daydiff
            if (consignee === "Select All") {
              setpgHeader("All Bill Received Pending List");
              return subreport.daydiff >= dayDiffThreshold;
            } else {
              setpgHeader(`Bill Received Pending List for ${consignee}`);
              return (
                subreport.daydiff >= dayDiffThreshold &&
                subreport.consignee === `${consignee}`
              );
            }
          } else if (reporttype === REPORT_TYPE.BILL_PASSING_PENDING) {
            let dayDiffThreshold = 0;
            if (reportsubtype === 1) {
              dayDiffThreshold = 7;
            }

            // Apply filtering based on consignee and daydiff
            if (consignee === "Select All") {
              setpgHeader("All Bill Passing Pending List");
              return subreport.daydiff >=dayDiffThreshold;
            } else {
              setpgHeader(`Bill Passing Pending List for ${consignee}`);
              return (
                subreport.daydiff >=dayDiffThreshold &&
                subreport.consignee === `${consignee}`
              );
            }
          } else if (reporttype === REPORT_TYPE.CRN_PENDING) {
            let dayDiffThreshold = 0;
            if (reportsubtype === 0) {
              dayDiffThreshold = 0;
            } else if (reportsubtype === 1) {
              dayDiffThreshold = 7;
            }

            // Apply filtering based on consignee and daydiff
            if (consignee === "Select All") {
              setpgHeader("All CRN Pending List");
              return subreport.daydiff >= dayDiffThreshold;
            } else {
              setpgHeader(`CRN Pending List for ${consignee}`);
              return (
                subreport.daydiff >= dayDiffThreshold &&
                subreport.consignee === `${consignee}`
              );
            }
          } else if (reporttype === REPORT_TYPE.PAYMENT_PENDING) {
            let dayDiffThreshold = 0;
            if (reportsubtype === 1) {
              dayDiffThreshold = 10;
            }

            // Apply filtering based on consignee and daydiff
            if (consignee === "Select All") {
              setpgHeader("All Payment Pending List");
              return subreport.daydiff >= dayDiffThreshold;
            } else {
              setpgHeader(`Payment Pending List for ${consignee}`);
              return (
                subreport.daydiff >= dayDiffThreshold &&
                subreport.consignee === `${consignee}`
              );
            }
          } else if (reporttype === REPORT_TYPE.PAID) {
            let dayDiffThreshold = 0;
            if (reportsubtype === 1) {
              dayDiffThreshold = 7;
            } else if (reportsubtype === 2) {
              dayDiffThreshold = 15;
            } else if (reportsubtype === 3) {
              dayDiffThreshold = 30;
            } else if (reportsubtype === 4) {
              dayDiffThreshold = 60;
            } else if (reportsubtype === 5) {
              dayDiffThreshold = 90;
            } else if (reportsubtype === 6) {
              dayDiffThreshold = 180;
            } else if (reportsubtype === 7) {
              dayDiffThreshold = 365;
            }

            // Apply filtering based on consignee and daydiff
            if (consignee === "Select All") {
              setpgHeader(
                "All Payment Paid List" +
                  " within Last " +
                  `${dayDiffThreshold}` +
                  " Days"
              );
              return subreport.daydiff <= dayDiffThreshold;
            } else {
              setpgHeader(
                "Payment Paid List for " +
                  `${consignee}` +
                  " within Last " +
                  `${dayDiffThreshold}` +
                  " Days"
              );
              return (
                subreport.daydiff <= dayDiffThreshold &&
                subreport.consignee === `${consignee}`
              );
            }
          }

          // If report type doesn't match, return all data (no filtering)
          return true;
        });

        setReportAllData(filteredData);

        const totalItems = filteredData.length;

        // console.log(totalItems);

        setTotalRows(totalItems);
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        setReportData(filteredData.slice(startIndex, endIndex));
      } catch (error) {
        setReportData([]);
        setTotalRows(0);
      } finally {
        //setPageLoader(false);
      }
    }, 300),
    [
      uname,
      currentPage,
      pageSize,
      columns,
      columnNames,
      reporttype,
      reportsubtype,
      srcinddata,
    ]
  );

  useEffect(() => {
    fetchData(srcinddata);
  }, [reporttype, reportsubtype,srcinddata,currentPage]);

  // useEffect(() => {
  //   // Fetch data when currentPage changes
  //   fetchData(srcinddata);
  // }, [currentPage]);
  
  // if (pageLoader) {
  //   return (
  //     <div className="loaderContainer">
  //       {" "}
  //       <CircularProgress />{" "}
  //     </div>
  //   );
  // }

  return (
    <div>
      <Card>
      <div className="input-groupHeading">
            {heading}

            </div>



        <CardContent>

  {/*-----------------------SEARCH BOX--------------------*/}
  {currentPage === 1 && reporttype !== REPORT_TYPE.USER_LIST ? (
            <SearchTextField
              label= {reporttype === REPORT_TYPE.PO_NOT_GENERATED?"Indent Number":"PO Number"}
              value={srcinddata}
              title={reporttype === REPORT_TYPE.PO_NOT_GENERATED?"Enter Indent Number":"Enter PO Number"}
              onChange={(e) => setSrcinddata(e.target.value)}
              adornment={
                <IconButton title={reporttype === REPORT_TYPE.PO_NOT_GENERATED?"Search Indent":"Search PO"}>
                  <SearchIcon />
                </IconButton>
              }
            />
          ) : null}



          {columns?.length && columnNames?.length ? (
            <ListDynamicTable
              columns={columns}
              columnNames={columnNames}
              data={reportData}
              totalRows={totalRows}
              pageSize={pageSize}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              showProceed={false}
            />
          ) : null}

          {/* -----------------------Export Button---------------------------------------- */}
          <div className="container mt-4"></div>

          <div className=" container mb-3 mt-2 col-12 gap-4 d-flex justify-content-center">
            <ExportToExcelCustomButton
              data={reportAllData}
              fileName={"POList"} //+ `${currentPage}`}
              columns={columns}
              columnNames={columnNames}
              buttonTitle="Export to Excel"
            />

            <ExportToPDFCustomButton
              data={reportAllData}
              fileName={"POList"}
              columns={columns}
              columnNames={columnNames}
              buttonTitle="Export to PDF"
              pageHeader={pgHeader}
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default PoReport;
